export default {
  footerText: "#687882",
  composerTextColor: "#4e5c65",
  composerBorderColor: "#687882",
  composerBackgroundColor: "rgba(255, 255, 255, 0.5)",
  composerIconColor: "#687882",
  composerIconHoverColor: "#5d6a74",
  endUserMessageBackgroundColor: "#4e5c65",
  endUserMessageTextColor: "white",
  agentMessageBackgroundColor: "#687882",
  agentMessageTextColor: "white",
  messageAuthorColor: "#687882",
  messageTimestampColor: "#687882",
  conversationRatingHeaderTextColor: "white",
  conversationRatingHeaderBackgroundColor: "rgba(255, 255, 255, 0.3)",
  conversationRatingBodyBackgroundColor: "rgba(255, 255, 255, 0.3)",
  gdprTextColor: "#687882",
  buttonBackgroundColor: "#e5e5e5",
  buttonTextColor: "#222222",
}
